export const PROMO_PARAM_MAPPING = {
  promo: 'promoCode',
  utm_source: 'utmSource',
  utm_campaign: 'utmCampaign',
  utm_medium: 'utmMedium',
  utm_content: 'utmContent',
  utm_term: 'utmTerm',
  pid: 'pid',
  clickid: 'clickid',
  http_referer: 'httpReferer',
};

export const MIN_PROMO_CODE_LENGTH = 30;
